module.exports = __webpack_public_path__ + "static/p12_I_sombraVacas-025ef487f1a5c41a1f7a845cba28cdfc.png";